import { connect } from 'react-redux'
import SelectionPage from './SelectionPage'
import { clearSelection, addOverlayPage } from '../../actionCreators'
import { selectedStompunkterOnCurrentPage } from '../../selectors/selectionPagination'
import * as pages from '../../constants/pages'

const mapStateToProps = (state, ownProps) => ({
   selectedStompunkter: selectedStompunkterOnCurrentPage(state)
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  onClear: () => dispatch(clearSelection()),
  onExport: () => dispatch(addOverlayPage(pages.EXPORT))
});

export default connect(mapStateToProps, mapDispatchToProps)(SelectionPage);



// WEBPACK FOOTER //
// ./src/components/Selection/SelectionPageContainer.js